import { __assign, __rest } from "tslib";
import React from 'react';
import cx from 'classnames';
import bcx from 'bem-classname';
import { Dropdown as RODropdown } from 'react-overlays';
export var DropdownToggle = function (props) {
    var componentClass = 'dropdown-toggle';
    var children = props.children, className = props.className, _a = props.custom, custom = _a === void 0 ? false : _a, _b = props.component, Component = _b === void 0 ? 'div' : _b, toggleProps = __rest(props, ["children", "className", "custom", "component"]);
    var classes = cx(bcx(componentClass, {
        custom: custom,
    }), className);
    return (React.createElement(RODropdown.Toggle, null, function (props) { return (React.createElement(Component, __assign({ className: classes }, toggleProps, props), children)); }));
};
//# sourceMappingURL=DropdownToggle.js.map